// initial chunk
import Vue from 'vue'
import VueRouter from 'vue-router'
import UserLogin from './components/pages/UserLogin'
import DossiersList from './components/pages/DossiersList'
import EchangesClientsList from './components/pages/EchangesClientsList'
import PageNotFound from './components/pages/PageNotFound'
import FichesResultatsList from "./components/pages/FichesResultatsList"
import FichesCreationsList from "./components/pages/FichesCreationsList"
import ProgrammesList from "./components/pages/ProgrammesList"
import ProspectsList from "./components/pages/ProspectsList"

Vue.use(VueRouter)

// Create the router
export default new VueRouter({
    mode: 'history',

    // set all routes
    routes: [
        {
            path: '/',
            redirect: '/dossiers',
        },

        {
            path: '/login',
            component: UserLogin,
            name: 'login',
        },

        {
            path: '/dossiers',
            component: DossiersList,
            name: 'dossiers',
        },

        {
            path: '/echanges',
            component: EchangesClientsList,
            name: 'echangesClients',
        },

        {
            path: '/fiches-creations',
            component: FichesCreationsList,
            name: 'fichesCreations',
        },

        {
            path: '/fiches-resultats',
            component: FichesResultatsList,
            name: 'fichesResultats',
        },

        {
            path: '/prospects',
            component: ProspectsList,
            name: 'prospects',
        },

        {
            path: '/programmes',
            component: ProgrammesList,
            name: 'programmes',
        },

        {
            path: '/dossiers/:id',
            component: () => import(/* webpackChunkName: "dossier" */ './components/pages/DossierItem'),
            props: route => ({id: parseInt(route.params.id)}),
            children: [
                {
                    path: '',
                    component: () => import(/* webpackChunkName: "dossier" */ './components/pages/dossier/DossierEdit'),
                    name: 'dossier',
                },

                {
                    path: 'infos-prospect',
                    component: () => import(/* webpackChunkName: "dossier" */ './components/pages/dossier/InfosProspect'),
                    name: 'infosProspect',
                },

                {
                    path: 'fiche-supervisions',
                    component: () => import(/* webpackChunkName: "dossier" */ './components/pages/dossier/DossierFicheSupervision'),
                    name: 'dossierFicheSupervision'
                },

                {
                    path: 'historique-mails',
                    component: () => import(/* webpackChunkName: "dossier" */ './components/pages/dossier/DossierHistoriqueMail'),
                    name: 'dossierHistoriqueMail',
                },

                {
                    path: 'historique-modifications',
                    component: () => import(/* webpackChunkName: "dossier" */ './components/pages/dossier/DossierHistoriqueModifications'),
                    name: 'dossierHistoriqueModifications',
                },

                {
                    path: 'fiche-resultat',
                    component: () => import(/* webpackChunkName: "dossier" */ './components/pages/dossier/FicheResultat'),
                    name: 'dossierFicheResultat',
                },

                {
                    path: 'fiche-tva',
                    component: () => import(/* webpackChunkName: "dossier" */ "./components/pages/dossier/FicheTva"),
                    name: 'dossierFicheTVA',
                },

                {
                    path: 'teletransmission',
                    component: () => import(/* webpackChunkName: "dossier" */ "./components/pages/dossier/Teletransmission"),
                    name: 'dossierTeletransmission',
                },

                {
                    path: 'programmes',
                    component: () => import(/* webpackChunkName: "dossier" */ "./components/pages/dossier/ClientLots"),
                    name: 'clientLots',
                },

                {
                    path: 'particularite',
                    component: () => import(/* webpackChunkName: "dossier" */ "./components/pages/dossier/DossierParticularite"),
                    name: 'dossierParticularite',
                },

                {
                    path: 'documents',
                    component: () => import(/* webpackChunkName: "dossier" */ "./components/pages/dossier/DossierDocuments"),
                    name: 'dossierDocuments',
                },

                {
                    path: 'pieces-comptables',
                    component: () => import(/* webpackChunkName: "dossier" */ "./components/pages/dossier/DossierPiecesComptables"),
                    name: 'dossierPiecesComptables',
                },
                {
                    path: 'echange-client',
                    component: () => import(/* webpackChunkName: "dossier" */ "./components/pages/dossier/DossierEchangesClient"),
                    name: 'dossierEchangesClient',
                    props: route => ({
                        newExchange: route.query.newExchange === 'true' || route.query.newExchange === '1',
                        sujetParent: Number(route.query.sujetParent),
                        sujet: Number(route.query.sujet),
                        incoming: route.query.incoming === 'true' || route.query.incoming === '1',
                    }),
                },
            ]
        },
        {
            path: '/configuration',
            component: () => import(/* webpackChunkName: "configuration" */ './components/pages/Configuration'),
            children: [
                {
                    path: 'lieux-production',
                    component: () => import(/* webpackChunkName: "configuration" */ './components/pages/configuration/LieuxProductionList'),
                    name: 'config-lieux-production',
                },
                {
                    path: 'lieux-collecte',
                    component: () => import(/* webpackChunkName: "configuration" */ './components/pages/configuration/LieuxCollecteList'),
                    name: 'config-lieux-collecte',
                },
                {
                    path: 'ged-types',
                    component: () => import(/* webpackChunkName: "configuration" */ './components/pages/configuration/GedTypeList'),
                    name: 'config-ged-types',
                },
            ]
        },
        {
            path: '/configuration',
            component: () => import(/* webpackChunkName: "configuration" */ './components/pages/Configuration'),
            children: [
                {
                    path: 'cabinets',
                    component: () => import(/* webpackChunkName: "configuration" */ './components/pages/configuration/CabinetsList'),
                    name: 'config-cabinets',
                },

                {
                    path: 'mails-types',
                    component: () => import(/* webpackChunkName: "configuration" */ './components/pages/configuration/MailsTypesList'),
                    name: 'config-mails-types',
                },

                {
                    path: 'fichiers',
                    component: () => import(/* webpackChunkName: "configuration" */ './components/pages/configuration/FichiersList'),
                    name: 'config-fichiers',
                },
            ]
        },

        {
            path: '/statistiques',
            component: () => import(/* webpackChunkName: "statistiques" */ './components/pages/StatistiquesTab'),
            children : [
                {
                    path: '',
                    component: () => import(/* webpackChunkName: "statistiques" */ './components/pages/statistiques/StatistiquesStatuts'),
                    name: 'statistiques',
                },

                {
                    path: 'production',
                    component: () => import(/* webpackChunkName: "statistiques" */ './components/pages/statistiques/StatistiquesProduction'),
                    name: 'stats-production',
                },

                {
                    path: 'avancement-production',
                    component: () => import(/* webpackChunkName: "statistiques" */ './components/pages/statistiques/StatistiquesAvancementProduction'),
                    name: 'stats-avancement-production',
                },

                {
                    path: 'avancement-supervision',
                    component: () => import(/* webpackChunkName: "statistiques" */ './components/pages/statistiques/StatistiquesAvancementSupervision'),
                    name: 'stats-avancement-supervision',
                },

                {
                    path: 'clients',
                    component: () => import(/* webpackChunkName: "statistiques" */ './components/pages/statistiques/StatistiquesClients'),
                    name: 'stats-clients',
                },

                {
                    path: 'reinvest',
                    component: () => import(/* webpackChunkName: "statistiques" */ './components/pages/statistiques/StatistiquesReinvest.vue'),
                    name: 'stats-reinvest',
                }
            ],
        },

        {
            path: '/partenaires',
            component: () => import(/* webpackChunkName: "partenaires" */ './components/pages/PartenairesTab'),
            children: [
                {
                    path: '',
                    component: () => import(/* webpackChunkName: "partenaires" */ './components/pages/partenaires/SieList'),
                    name: 'partenairesSie',
                },

                {
                    path: 'cga',
                    component: () => import(/* webpackChunkName: "partenaires" */ './components/pages/partenaires/CgaList'),
                    name: 'partenairesCga',
                },

                {
                    path: 'greffes',
                    component: () => import(/* webpackChunkName: "partenaires" */ './components/pages/partenaires/GreffesList'),
                    name: 'partenairesGreffes',
                },

                {
                    path: 'provenances',
                    component: () => import(/* webpackChunkName: "partenaires" */ './components/pages/partenaires/ProvenancesList'),
                    name: 'partenairesProvenances',
                },
            ]
        },

        {
            path: '/administration',
            component: () => import(/* webpackChunkName: "admin" */ './components/pages/AdminTab'),
            children: [
                {
                    path: 'utilisateurs',
                    component: () => import(/* webpackChunkName: "admin" */ './components/pages/administration/UsersList'),
                    name: 'adminUsers',
                },

                {
                    path: 'equipes',
                    component: () => import(/* webpackChunkName: "admin" */ './components/pages/administration/EquipesList'),
                    name: 'adminEquipes',
                },

                {
                    path: 'taches',
                    component: () => import(/* webpackChunkName: "admin" */ './components/pages/administration/JobsList'),
                    name: 'adminJobs',
                },

                {
                    path: 'alertes',
                    component: () => import(/* webpackChunkName: "admin" */ './components/pages/administration/AlertsList'),
                    name: 'adminAlerts',
                },
            ]
        },

        {
            path: '*',
            component: PageNotFound,
            name: 'notFound',
        },
    ],
})
